import React, { Component } from 'react';
import { connect } from 'react-redux';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import './SubContractorsUnionTrades.css';
import { Col } from 'react-bootstrap';
import SubContractorsList from './SubContractorsList';
import SubContractorsForm from './SubContractorsForm';

import leftArrowPng from '../../../../images/left-arrow.png';
import { goHistoryBack } from '../../../../actions/admin/work-orders/work-orders';
import {
  getDontKnowUnions,
  getNoUnions,
  getNewSubContractor,
  getSelectedSubContractorsId,
  getSelectedUnionTradesId,
  getShowNewContractor,
  getSubContractorAnswer,
  getValidationError,
  getUnionTradesValidationError,
} from '../../../../selectors/admin/work-orders/creation/sub-contractors-union-trades';
import {
  addSubContractor,
  answerQuestion,
  cancelAddSubContractor,
  confirmSubContractorsUnionTradesRequest,
  createSubContractorRequest,
  formValueChange,
  initializeComponentAppState,
  loadContractorsRequest,
  loadUnionTradesRequest,
  removeSubContractor,
  selectSubContractor,
  selectUnionTrade,
} from '../../../../actions/admin/work-orders/creation/sub-contractors-union-trades';
import {
  getContractors,
  getCurrentWorkOrder,
  getTasks,
  getUnionTrades,
} from '../../../../selectors/admin/work-orders/work-orders';
import { showWOCancellationModal } from '../../../../actions/admin/work-orders/creation/creation';
import CancelWorkOrder from './CancelWorkOrder';
import { getNewWOProcessStarted } from '../../../../selectors/admin/work-orders/creation/creation';
import { simpleScrollToTop } from '../../../../services/utils/scroller-util';

class SubContractorsUnionTrades extends Component {
  componentDidMount() {
    let currentSubContractorsId = [];
    let currentUnionTradesId = [];
    let dontKnowSubContractor = false;
    let dontKnowUnions = false;
    if (this.props.currentWorkOrder !== null) {
      currentSubContractorsId = this.props.currentWorkOrder.propietary_sub_contractors.map(
        (element) => element.id
      );
      currentUnionTradesId = this.props.currentWorkOrder.unions.map(
        (element) => element.id
      );
      dontKnowSubContractor = this.props.currentWorkOrder.dont_know_subcons;
      dontKnowUnions = this.props.currentWorkOrder.dont_know_unions;
    }

    this.props.dispatch(
      initializeComponentAppState(
        currentSubContractorsId,
        dontKnowSubContractor,
        dontKnowUnions
      )
    );
    this.props.dispatch(
      loadContractorsRequest(
        currentSubContractorsId,
        this.props.tasks.map((task) => task.trade.id)
      )
    );
    this.props.dispatch(loadUnionTradesRequest(currentUnionTradesId));
  }

  handleSubContractorSelection = (contractorId) => {
    this.props.dispatch(selectSubContractor(contractorId));
  };

  handleAddSubContractor = () => {
    this.props.dispatch(addSubContractor());
  };

  handleRemoveSubContractor = (id) => {
    this.props.dispatch(removeSubContractor(id));
  };

  handleQuestionResponse = (value) => {
    this.props.dispatch(answerQuestion(value));
  };

  handleFormCancel = () => {
    this.props.dispatch(cancelAddSubContractor());
  };

  handleFormChange = (attribute, value) => {
    this.props.dispatch(formValueChange(attribute, value));
  };

  handleFormSubmit = () => {
    this.props.dispatch(
      createSubContractorRequest(this.props.newSubContractor)
    );
  };

  handleContinue = () => {
    const promise = this.props.dispatch(
      confirmSubContractorsUnionTradesRequest(
        this.props.currentWorkOrder.id,
        this.props.selectedSubContractorsId.map((element) => {
          return element;
        }),
        this.props.subContractorAnswer,
        this.props.selectedUnionTradesId,
        this.props.dontKnowUnions,
        this.props.noUnions,
        this.props.newWOProcessStarted
      )
    );

    if (promise !== null) {
      promise.then((response) => {
        if (response.ok) {
          simpleScrollToTop();
        }
      });
    }
  };

  handleBackArrow = () => {
    this.props.dispatch(goHistoryBack());
  };

  handleCancelOrder = (event) => {
    event.preventDefault();
    this.props.dispatch(showWOCancellationModal());
  };

  handleUnionTradesSelection = (unionTradeId) => {
    this.props.dispatch(
      selectUnionTrade(
        unionTradeId,
        this.props.selectedUnionTradesId,
        this.props.unionTrades
      )
    );
  };

  render() {
    return (
      <div className="sub-contractors">
        <RouteTitle
          titles={['WORK ORDERS', 'WO #' + this.props.currentWorkOrder.number]}
        />

        <div className="full-title">
          Work Order #{this.props.currentWorkOrder.number}
        </div>

        <Col md={8} className="column">
          <div className="content-container">
            {!this.props.showNewContractor ? (
              <div className="contractors-union-trades">
                {
                  /* Only show back button if WO is under creation */
                  this.props.newWOProcessStarted && (
                    <div className="image-back-container">
                      <img
                        src={leftArrowPng}
                        alt={'left-arrow'}
                        onClick={this.handleBackArrow}
                      />
                    </div>
                  )
                }

                <SubContractorsList
                  subContractorAnswer={this.props.subContractorAnswer}
                  subContractors={this.props.subContractors}
                  selectedSubContractorsId={this.props.selectedSubContractorsId}
                  validationError={this.props.validationError}
                  onAddSubContractor={this.handleAddSubContractor}
                  onQuestionResponse={this.handleQuestionResponse}
                  onRemoveSubContractor={this.handleRemoveSubContractor}
                  onSubContractorSelection={this.handleSubContractorSelection}
                />

                <div className="button-container">
                  <input
                    className="btn button button-orange"
                    value="Continue"
                    type="button"
                    onClick={this.handleContinue}
                  />
                  <input
                    className="btn button button-white"
                    value="Cancel Order"
                    type="button"
                    onClick={this.handleCancelOrder}
                  />
                </div>
              </div>
            ) : (
              <SubContractorsForm
                data={this.props.newSubContractor}
                validationError={this.props.validationError}
                onCancel={this.handleFormCancel}
                onFormChange={this.handleFormChange}
                onFormSubmit={this.handleFormSubmit}
              />
            )}
          </div>
        </Col>

        <CancelWorkOrder />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    dontKnowUnions: getDontKnowUnions(state),
    noUnions: getNoUnions(state),
    newSubContractor: getNewSubContractor(state),
    newWOProcessStarted: getNewWOProcessStarted(state),
    subContractorAnswer: getSubContractorAnswer(state),
    subContractors: getContractors(state),
    selectedSubContractorsId: getSelectedSubContractorsId(state),
    selectedUnionTradesId: getSelectedUnionTradesId(state),
    showNewContractor: getShowNewContractor(state),
    tasks: getTasks(state),
    unionTrades: getUnionTrades(state),
    validationError: getValidationError(state),
    unionTradesValidationError: getUnionTradesValidationError(state),
  };
})(SubContractorsUnionTrades);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/SubContractorsUnionTrades.js